<template>
  <div class="container">
    <h4 class="container-title" >中医治未病中心</h4>
    <h5 class="container-title__lite" style="color: #a5a5a5; margin: 1rem 0">-- 五禽戏演示片 --</h5>
    <div class="player">
<!--      <video-player  class="video-player vjs-custom-skin"-->
<!--                     ref="videoPlayer"-->
<!--                     :playsinline="true"-->
<!--                     :options="playerOptions"-->
<!--                     @play="onPlayerPlay($event)"-->
<!--                     @pause="onPlayerPause($event)"-->
<!--      >-->
<!--      </video-player>-->
      <div class="prism-player" id="J_prismPlayer"></div>
      <h5 style="color: #a5a5a5;margin-top: 20px">点击下方切换语言↓</h5>
      <toggle-button
                     :value="true"
                     color="#1989fa"
                     :width = "150"
                     :height="30"
                     :labels="{checked: 'English version', unchecked: '切换到中文版本'}"
                     :font-size="14"
                     @change="changeVersion"
                     style="margin-bottom: 10px"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4',
          src: 'https://yyk5.gxzyy.com.cn/v/bdj.mp4' // 你的m3u8地址（必填）
        }],
        poster: 'https://yyk5.gxzyy.com.cn/v/cover.jpg', // 你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试' // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      },
      videoTitle: this.$store.state.VOD_NANE,
      vodAddress: this.$store.state.VOD_ADDRESS,
      vodAddress_en: this.$store.state.VOD_ADDRESS_EN,
      vodCover: this.$store.state.VOD_COVER,
      player: null
    }
  },
  components: {
  },
  methods: {
    changeVersion({value}) {
        if (this.player) {
          const  url = value ? this.vodAddress : this.vodAddress_en
          console.log(url)
          this.player.loadByUrl(url)
        }
    },
    onPlayerPlay (player) {
      // alert('play')
    },
    onPlayerPause (player) {
      // alert('pause')
    },
    initPlayer (auth) {
      // eslint-disable-next-line no-undef,no-unused-vars
      const player = new Aliplayer({
        'id': 'J_prismPlayer',
        'source': this.vodAddress,
        'cover': this.vodCover,
        'width': '100%',
        'autoplay': true,
        'isLive': false,
        'rePlay': false,
        'skinLayout': [
          { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              { name: 'progress', align: 'blabs', x: 0, y: 44 },
              { name: 'playButton', align: 'tl', x: 15, y: 12 },
              { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
              { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
              { name: 'setting', align: 'tr', x: 15, y: 12 },
              { name: 'volume', align: 'tr', x: 5, y: 10 }
            ]
          }],
        'playsinline': true,
        'preload': true,
        'controlBarVisibility': 'hover',
        'useH5Prism': true
      }, function (player) {
        console.log('The player is created')
      })
      this.player = player
    }
  },
  mounted () {
    // let data = new FormData()
    // data.append('videoId', '154235c2ff424d16b1e2f6a483a5776e')
    // data.append('auth', '154235c2ff424d1')
    // axios.post('/v/vod.php', data).then(res => {
    //   if (res.status === 200) {
    //     console.log(res.data)
    //     this.initPlayer(res.data.auth)
    //   }
    // })
    this.initPlayer()
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .container {
    height: 100vh;
    padding: 1rem 0;
    background-color: #f4f4f4;
    color: #a2a2a2;
    text-align: center;
  }
  .container-title {
    padding: 1rem 0;
    margin: 0 1rem;
    border-radius: 12px;
    transition: background 0.1s, color 0.1s;
    background: linear-gradient(145deg, #ffffff, #dcdcdc);
    box-shadow: 3px 3px 5px #bebebe, -3px -3px 5px #ffffff;
  }
  .player {
    margin: 0 1rem;
    padding: 3rem 0 .5rem 0;
    border-radius: 18px;
    background: #f4f4f4;
    box-shadow: 3px 3px 6px #bebebe, -3px -3px 6px #ffffff;
  }

  .prism-player {
    border-radius:  18px 18px 0 0 !important;
    background: none;
  }
</style>
